// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"b8b966e2","453":"c68d03a1","967":"5c77aecd"}[chunkId] + ".chunk.js";
};